export default __webpack_public_path__ + "static/media/photo-camera.39397ef6.svg";